export default __webpack_public_path__ + "static/media/invoice.97a81528.svg";